export const formatCurrency = (cents) => {
  const value = Number(cents || 0) / 100;
  return value.toLocaleString('en-US', {
    style: 'currency',
    currency: 'USD',
  });
};

// /admin/final-registrations returns one row per booth. Group them so each
// vendor appears once with a list of their booths and a combined amount paid.
export const groupFinalRegistrations = (registrations) => {
  const byVendor = new Map();
  for (const r of registrations) {
    const key = r.vendor_id ?? `${r.email}|${r.business_name}`;
    if (!byVendor.has(key)) {
      byVendor.set(key, {
        vendor_id: r.vendor_id,
        business_name: r.business_name,
        first_name: r.first_name,
        last_name: r.last_name,
        phone: r.phone,
        email: r.email,
        website: r.website,
        address: r.address,
        city: r.city,
        state: r.state,
        zip_code: r.zip_code,
        description: r.description,
        category_name: r.category_name,
        category_slug: r.category_slug,
        category_other_description: r.category_other_description,
        exhibit_type: r.exhibit_type,
        check_in_date: r.check_in_date,
        booths: [],
        amount_paid_cents: 0,
      });
    }
    const entry = byVendor.get(key);
    entry.booths.push({
      booth_number: r.booth_number,
      is_corner: r.is_corner,
      needs_electricity: r.needs_electricity,
    });
    entry.amount_paid_cents += Number(r.amount_paid_cents || 0);
  }
  return Array.from(byVendor.values()).sort((a, b) =>
    (a.business_name || '').localeCompare(b.business_name || '')
  );
};
